import React from "react";
import { useCombinedStore } from "../store";
import * as AlfredoStyles from "../styles/components/SupplyCentral";

const LastOptions: React.FC = () => {
  return (
    <AlfredoStyles.LastOptionsContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>widgets</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Central de Suprimentos</AlfredoStyles.Title>
      </AlfredoStyles.Card>
    </AlfredoStyles.LastOptionsContainer>
  );
};

export default LastOptions;
